import WorkItemMetadataProvider from './work_item_metadata_provider.vue?vue3';
export default {
    name: 'WorkItemsApp',
    components: {
        WorkItemMetadataProvider
    },
    props: {
        rootPageFullPath: {
            type: String,
            required: false,
            default: undefined
        }
    },
    computed: {
        pageKey () {
            return this.$route.params.iid || this.$route.name;
        }
    }
};
